import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/apis/client";
import type { IUpdateDomainRequest, IDomainResponse } from "./types";

/**
 * 도메인 수정 API 함수
 */
const updateDomain = async (
  examConfigId: string,
  subject: string,
  domainId: string,
  data: IUpdateDomainRequest
): Promise<IDomainResponse> => {
  const response = await apiClient.patch<IDomainResponse>(
    `/exam_configs/${examConfigId}/subjects/${subject}/domains/${domainId}`,
    data
  );
  return response.data;
};

/**
 * 도메인 수정 훅
 */
export const useUpdateDomain = (
  examConfigId: string,
  subject: string,
  domainId: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IUpdateDomainRequest) =>
      updateDomain(examConfigId, subject, domainId, data),
    onSuccess: () => {
      // 도메인 목록 쿼리 무효화
      queryClient.invalidateQueries({
        queryKey: ["domains", examConfigId, subject],
      });
      // ExamConfig 쿼리 무효화 (도메인 정보 포함)
      queryClient.invalidateQueries({
        queryKey: ["examConfig", examConfigId],
      });
      queryClient.invalidateQueries({
        queryKey: ["examConfigs"],
      });
    },
  });
};
